import Cookie from 'js-cookie'
import client from './index'

const getCookies = async (httpClient) => {
  const cookie = Cookie.get('XSRF-TOKEN')
  if (!cookie)
    await httpClient.get('sanctum/csrf-cookie')
}
const getData = async(type, url, request = {}, options = {}) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.get(`${url}`, { params: request, ...options })
}
const postData = async (type, url, data, options = {}) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.post(`${url}`, data, options)
}
const patchData = async (type, url, data) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.patch(`${url}`, data)
}
const putData = async (type, url, data) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.put(`${url}`, data)
}
const destroyData = async (type, url) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.delete(`${url}`)
}
const uploadData = async (type, url, data, skipCookies = false) => {
  const httpClient = client[type]
  if(!skipCookies){
    await getCookies(httpClient)
  }
  return httpClient.post(`${url}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
}
const downloadFile = async (type, url) => {
  const httpClient = client[type]
  await getCookies(httpClient)
  return httpClient.get(`${url}`, { responseType: 'blob' })
}

const errorHelper = (err) => {
  const error = err?.response?.data
  return {
    msg: error?.msg || 'An error occurred, please try again',
    status: error?.status || 0,
  }
}
export {
  getData,
  postData,
  patchData,
  putData,
  destroyData,
  uploadData,
  downloadFile,
  errorHelper,
}
